// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9 1.84229L15 5.38567L22 2.49999V18.0744L15 22.1577L9 18.6143L2 21.5V5.92562L9 1.84229Z"}}]};

const MapOutlineFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-outline-filled',
    ref,
    icon: element,
  },
));

MapOutlineFilledIcon.displayName = 'MapOutlineFilledIcon';

export default MapOutlineFilledIcon;
